import {VanillaHCaptchaWebComponent} from "./hcaptcha";

customElements.define('h-captcha', VanillaHCaptchaWebComponent);
